module.exports = __webpack_public_path__ + "logo.png?61a069f97c70b43c49762ffce4714025";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 79
// module chunks = 10